export class EventTimeModel {
    constructor(hour, minute, amOrPm = 'pm') {
        this.hour = amOrPm === 'pm' ? hour + 12 : hour;
        this.minute = minute;
    }
}
